// DOM 相关

export function forceLayout(el) {
  return el.offsetWidth
}

export function getElement (context, selector) {
  if (arguments.length < 2) {
    selector = context
    context = document
  }
  return context.querySelector(selector)
}

export function hasClass(element, classes) {
  var contains, i = 0
  if (element.classList) {
    classes = classes.split(/\s+/).filter(function (s) { return s })
    contains = true
    for (; i < classes.length; ++i) {
      if (!element.classList.contains(classes[i])) {
        contains = false
        break
      }
    }
    return contains
  } else {
    classes = classes.split(/\s+/).filter(function (s) { return s })
    contains = true
    var tmp = element.className
    for (; i < classes.length; ++i) {
      if (tmp.indexOf(classes[i]) === -1) {
        contains = false
        break
      }
    }
    return contains
  }
}

export function addClass(element, classes) {
  if (element.classList) {
    classes = classes.split(/\s+/).filter(function (s) { return s })
    element.classList.add.apply(element.classList, classes)
  } else {
    var tmp = element.className
    classes = classes.split(/\s+/).filter(function (s) { return s })
    for (var i = 0; i < classes.length; ++i) {
      var c = classes[i]
      if (!hasClass(element, c)) {
        tmp = tmp.replace(/\s+|$/, ' ' + classes)
      }
    }
    element.className = tmp
  }
  return element
}

export function removeClass(element, classes) {
  if (element.classList) {
    classes = classes.split(/\s+/).filter(function (s) { return s })
    element.classList.remove.apply(element.classList, classes)
  } else {
    var tmp = element.className
    classes = classes.split(/\s+/).filter(function (s) { return s })
    for (var i = 0; i < classes.length; ++i) {
      var c = classes[i]
      if (hasClass(element, c)) {
        tmp = tmp.replace(new RegExp(c, 'g'), '')
      }
    }
    element.className = tmp
  }
  return element
}

// @TODO
// styles

// @TODO
// attributes
